/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { Input, Modal, TextArea, useForm } from 'linkwithus';
import './styles.scss';
import { motion } from 'framer-motion';
import config from 'config';
import { notification } from 'antd';
import { useTranslation } from 'react-i18next';
import SiteButton from 'components/SiteButton';
import FileUploader from 'components/FileUploader';
import {
    ModalMode,
    IEditCountyEntityModalForm,
    IEditCountyEntityModalModalProps,
} from './interface';
import { contentSettingsModalMotion } from './animation';

function EditCountyEntityModal({
    modalVisibility,
    close,
    item,
    mode = ModalMode.Edit,
    updateList,
    url,
}: IEditCountyEntityModalModalProps) {
    const { t } = useTranslation();
    const [imageUrl, setImageUrl] = useState<string>();
    const [imageVisibility, setImageVisibility] = useState(false);

    const { register, form, submit, updateForm, setForm } =
        useForm<IEditCountyEntityModalForm>({
            url: `${url}/${mode === ModalMode.Edit && item ? item.Id : ''}`,
            type: mode === ModalMode.Edit ? 'PUT' : 'POST',
            onSuccess: () => {
                notification.success({
                    message: t('general.SUCCESS'),
                    description: t(
                        `countyPage.${
                            mode === ModalMode.Edit
                                ? 'INFO_CHANGED_WITH_SUCESS'
                                : 'ENTITY_CREATED_WITH_SUCCESS'
                        }`,
                    ),
                });
                updateList();
                close();
            },
            onError: (data, error: any) => {
                const errorCode = Number(error.errorCode) || 0;
                notification.error({
                    message: t(`general.ERROR`),
                    description: t(`errors.${errorCode}`),
                });
                updateList();
                close();
            },
            resolveData(rawForm) {
                const data = new FormData();
                Object.keys(rawForm).forEach(key => {
                    if (key === 'photo') {
                        rawForm.photo.forEach((f: any) => {
                            data.append('photo', f as any);
                        });
                    } else
                        data.append(
                            key,
                            rawForm[
                                key as keyof IEditCountyEntityModalForm
                            ] as any,
                        );
                });
                return data;
            },
        });

    useEffect(() => {
        if (modalVisibility && mode === ModalMode.Edit && !item) {
            close();
        }
        if (modalVisibility && mode === ModalMode.Edit && item) {
            const currentDate = new Date();
            updateForm('name', item.Name);
            updateForm('description', item.Info);
            setImageUrl(
                `${config.API_URL}${url}/images/${item.Id}?date=${currentDate}`,
            );
            setTimeout(() => {
                setImageVisibility(true);
            }, 100);
        }
        if (!modalVisibility) {
            setForm({});
            setImageVisibility(false);
        }
        if (modalVisibility && mode === ModalMode.Create) {
            setImageUrl(undefined);
            setTimeout(() => {
                setImageVisibility(true);
            }, 100);
        }
    }, [modalVisibility]);

    return (
        <Modal
            visible={modalVisibility}
            close={close}
            className='edit-county-entity-modal'
            width={700}
        >
            <motion.div
                {...contentSettingsModalMotion}
                className='edit-county-entity-modal__content'
            >
                <p className='edit-county-entity-modal__content__title'>
                    {t(
                        `countyPage.${
                            mode === ModalMode.Edit
                                ? 'EDIT_ENTITY'
                                : 'NEW_ENTITY'
                        }`,
                    )}
                </p>
                <div className='edit-county-entity-modal__content__body'>
                    <div className='edit-county-entity-modal__content__body__img'>
                        {imageVisibility && (
                            <FileUploader
                                {...register('photo')}
                                initial={imageUrl}
                                className='circular'
                            />
                        )}
                    </div>
                    <p className='edit-county-entity-modal__content__body__label'>
                        {t('form.NAME')}
                    </p>
                    <Input
                        {...register('name', {
                            required: true,
                            resolveError: () =>
                                `${t('form.NAME')} ${t('form.REQUIRED_FIELD')}`,
                        })}
                        className='edit-county-entity-modal__content__body__field'
                    />
                    <p className='edit-county-entity-modal__content__body__label'>
                        {t('form.DETAILS')}
                    </p>
                    <TextArea
                        {...register('description', {
                            required: true,
                            resolveError: () =>
                                `${t('form.DETAILS')} ${t(
                                    'form.REQUIRED_FIELD',
                                )}`,
                        })}
                        autoSize
                        onPressEnter={() => {
                            //
                        }}
                        className='edit-county-entity-modal__content__body__field president-text-area'
                    />
                </div>
                <div className='edit-county-entity-modal__content__footer'>
                    <SiteButton
                        text={t('general.CANCEL')}
                        type='primary'
                        className='edit-county-entity-modal__content__footer__button grey'
                        onClick={close}
                    />
                    <SiteButton
                        text={t('form.SAVE_CHANGES')}
                        type='primary'
                        className='edit-county-entity-modal__content__footer__button'
                        onClick={submit}
                        disabled={
                            mode === ModalMode.Create &&
                            (!form.name ||
                                !form.photo ||
                                !form.description ||
                                (form.photo &&
                                    Array.isArray(form.photo) &&
                                    !(form.photo.length > 0)))
                        }
                    />
                </div>
            </motion.div>
        </Modal>
    );
}

export default EditCountyEntityModal;
